<template>
    <section class="formatter">
        <div class="d-flex gap-5 groups">
            <TimezonePickerInput v-model="clone.isWeekday.fromTimezone" title="From Timezone" />
        </div>
        <div class="d-flex gap-5 groups">
            <FormatPickerInput v-model="clone.isWeekday.fromFormat" title="From Format" />
        </div>
        <div class="d-flex gap-5 groups">
            <LocalePickerInput v-model="clone.isWeekday.fromLocale" title="From Locale" />
        </div>
        <div class="d-flex gap-5">
            <div class="editor-row customize-editor-minimize">
                <div class="editor-row-title">Weekday Days</div>
                <div class="weekday-days">
                    <a-checkbox-group v-model="clone.isWeekday.weekdayDays">
                        <a-checkbox value="1">Monday</a-checkbox>
                        <a-checkbox value="2">Tuesday</a-checkbox>
                        <a-checkbox value="3">Wednesday</a-checkbox>
                        <a-checkbox value="4">Thursday</a-checkbox>
                        <a-checkbox value="5">Friday</a-checkbox>
                    </a-checkbox-group>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import _ from "lodash";
import log2 from "../../../../../../../../../utils/log2";
import TiptapEditor from "../../../../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
import FormatPickerInput from "../inputs/FormatPickerInput.vue";
import LocalePickerInput from "../inputs/LocalePickerInput.vue";
import TimezonePickerInput from "../inputs/TimezonePickerInput.vue";

const log = log2("DateIsWeekday.vue");
export default {
    name: "DateIsWeekday",
    components: { TiptapEditor, FormatPickerInput, LocalePickerInput, TimezonePickerInput },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            mode: "date.isWeekday",
            inputs: [""],
            isWeekday: {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en",
                weekdayDays: ["1", "2", "3", "4", "5"] // Default: Monday to Friday
            }
        };
        if (!clone.isWeekday) {
            clone.isWeekday = {
                fromFormat: "YYYY-MM-DD",
                fromTimezone: "UTC",
                fromLocale: "en",
                weekdayDays: ["1", "2", "3", "4", "5"] // Default: Monday to Friday
            };
        }
        return {
            clone
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            }
        },
        value(newValue) {
            if (_.isEqual(newValue, this.clone)) return;
            this.clone = _.cloneDeep(newValue);
        }
    }
};
</script>

<style lang="scss" scoped>
section.formatter {
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;

    .groups {
        width: 100%;
        display: flex;
        gap: 5px;
        justify-content: space-between;

        .format-picker-section,
        .locale-picker-section,
        .timezone-picker-section {
            width: 100%;
        }
    }

    .weekday-days {
        margin-top: 10px;
        
        .ant-checkbox-group {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
        }
    }
}
</style> 